/**
 * Resolves with `fn()` result or rejects after `ms`. Use so UI loaders don't hang on slow networks.
 */
export async function fetchWithTimeout(fn, ms = 12000, label = 'request') {
  let timer;
  try {
    return await Promise.race([
      Promise.resolve().then(fn),
      new Promise((_, reject) => {
        timer = setTimeout(() => {
          reject(new Error(`${label} timed out after ${ms}ms`));
        }, ms);
      }),
    ]);
  } finally {
    if (timer) clearTimeout(timer);
  }
}
